var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "box" }, [
    _c("h1", { staticClass: "title is-5" }, [_vm._v("Datos básicos")]),
    _vm._v(" "),
    _c("div", { staticClass: "field" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Nombre")]),
      _vm._v(" "),
      _c("div", { staticClass: "control" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.model.nombre,
              expression: "model.nombre",
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: { required: true },
              expression: "{required:true}",
            },
          ],
          staticClass: "input",
          class: { "is-danger": _vm.errors.has("nombre", "serie") },
          attrs: { name: "nombre", "data-vv-scope": "serie" },
          domProps: { value: _vm.model.nombre },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.model, "nombre", $event.target.value)
            },
          },
        }),
      ]),
      _vm._v(" "),
      _vm.errors.has("nombre", "serie")
        ? _c("span", { staticClass: "help is-danger" }, [
            _vm._v(_vm._s(_vm.errors.first("nombre", "serie"))),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "field" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Descripcion")]),
      _vm._v(" "),
      _c("div", { staticClass: "control" }, [
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.model.descripcion,
              expression: "model.descripcion",
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: { required: true },
              expression: "{required:true}",
            },
          ],
          staticClass: "textarea",
          class: { "is-danger": _vm.errors.has("descripcion", "serie") },
          attrs: { name: "descripcion", "data-vv-scope": "serie", rows: "2" },
          domProps: { value: _vm.model.descripcion },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.model, "descripcion", $event.target.value)
            },
          },
        }),
      ]),
      _vm._v(" "),
      _vm.errors.has("descripcion", "serie")
        ? _c("span", { staticClass: "help is-danger" }, [
            _vm._v(_vm._s(_vm.errors.first("descripcion", "serie"))),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "has-text-right" }, [
      _c(
        "button",
        { staticClass: "button is-primary", on: { click: _vm.submitEdit } },
        [_c("i", { staticClass: "fas fa-save fa-fw" }), _vm._v(" Guardar\n  ")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }